import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import MasterLeftPanel from "../include/MasterLeftPanel";
import axios from "axios";
import Global from "../../APIConfig";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthUser from "../../AuthUser";
import { useNavigate, useParams } from "react-router-dom";
import MainLoader from "../Loaders/MainLoader";

function CmsDetail() {
    let navigate = useNavigate();
    const { id } = useParams();
    const { headers1, logout } = AuthUser();
    const [loading, setLoading] = useState(true);
    const [cmsData, setCmsData] = useState(null);
    const [logo, setLogo] = useState('');

    useEffect(() => {
        GetCmsDetail();
        systemdefaultdata();
    }, []);

    const systemdefaultdata = () =>
        {
          axios({
            method: 'post',
            url: Global.baseUrl+'systemdefaultlogo',
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
              setLogo(response.data.value);
            }
            else
            {
              setLoading(false);
              setLogo('');
            }
          })
          .catch(function (error) {
            setLoading(false);
            console.log(error);
          });
        }

    const GetCmsDetail = () => {
        setLoading(true);
        axios({
            method: 'post',
            url: Global.baseUrl + 'FetchCmsDetail',
            headers: headers1,
            data: {
                id: id
            }
        })
        .then(function (response) {
            if (response.data.status == 200) {
                setCmsData(response.data.value);
            } else {
                toast.error(response.data.message);
            }
            setLoading(false);
        })
        .catch(function (error) {
            if (error.response.status == 401) {
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            setLoading(false);
        });
    }

    return (
        <>
            <div className='container'>
                {loading ? <MainLoader /> :
                    <>
                        <div class="text-center mb-5">
                            <img src={`${Global.logoUrl}${logo}`} className="img-fluid" style={{ maxHeight: '100px' }} alt="Logo"/>
                        </div>
                        <div class="card card-body border-0 shadow table-wrapper table-responsive">
                            {cmsData && (
                                <div class="p-4">
                                    <div class="mb-4 text-center">
                                        <h3 class="h4 mb-3">{cmsData.title}</h3>
                                    </div>
                                    <div class="mb-4">
                                        <div class="fs-5" style={{ textAlign: 'justify' }} dangerouslySetInnerHTML={{ __html: cmsData.matter }} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                }
            </div>
        </>
    );
}

export default CmsDetail;
